import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['deleteModalVisible'] = false,
  action: Action,
): RootState['deleteModalVisible'] {
  switch (action.type) {
    case 'DELETE_MODAL_VISIBLE_SET': {
      return action.payload
    }

    default:
      return state
  }
}
